// removed by extract-text-webpack-plugin
module.exports = {"warning":"alert__warning__K49Ss","warning__icon":"alert__warning__icon__3lW6r","warning__message":"alert__warning__message__1BG6N","alert":"alert__alert__3Cu1I","alert-no-border":"alert__alert-no-border__1TWdO","alert__icon":"alert__alert__icon__3IFD0","alert__message":"alert__alert__message__2Lxr9","warning-no-icon":"alert__warning-no-icon__2_I4L","warning-no-icon__icon":"alert__warning-no-icon__icon__2h12K","warning-no-icon__message":"alert__warning-no-icon__message__1-SGa","alert-no-border__icon":"alert__alert-no-border__icon__zbaTW","alert-no-border__message":"alert__alert-no-border__message__2sKz5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/details/alert.scss
// module id = 1292
// module chunks = 1